import { combineReducers } from '@reduxjs/toolkit';

import ProductFormReducer from './form/reducer';
import ProductSelectDataReducer from './select/reducer';
import ProductManagementReducer from './management/reducer';

const ProductReducer = combineReducers({
  form: ProductFormReducer,
  select: ProductSelectDataReducer,
  management: ProductManagementReducer,
});

export default ProductReducer;
